export default __webpack_public_path__ + "static/media/dropdown.d3c36389.svg";